import { TransformedPhoto } from './transformed-photo.viewmodel';
import { BehaviorSubject } from 'rxjs';

export interface Photo {
    photoId: string;
    thumbnail?: string;
    list?: string;
    medium?: string;
    gallery?: string;
    large?: string;
    fullSize?: string;
    plusSize?: string;
    transformedPhoto?: TransformedPhoto;
    loading: boolean;
    hasError: boolean;
    errorMessage?: string;
}
